import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BackButton from '../../components/common/BackButton';
import background from '../../assets/portfoliodetailsheader.svg'
import { useTranslation } from 'react-i18next';
import TimelineSelector from '../../components/portfolioDetails/TimelineSelector';
import PortfolioProgress from '../../components/portfolioDetails/PortfolioProgress';
import PortfolioDetailsCircle from '../../components/portfolioDetails/PortfolioDetailsCircle';
import { useAppDispatch, useAppSelector } from '../../store/reducers/store';
import { loadPortfolioDetails } from '../../store/actions/portfolioDetails';
import PortfolioMenu from '../../components/portfolioDetails/PortfolioMenu';
import PortfolioDetailsTabContent from '../../components/portfolioDetails/PorfolioDetailsTabContent';

const PortfolioDetails: React.FC = () => {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const portfolio = useAppSelector(state => state.portfolioDetails.portfolio);

    useEffect(() => {
        if (id === undefined){
            navigate(-1);
        }
        if (portfolio === undefined || portfolio.id !== id){
            dispatch(loadPortfolioDetails(id as string));
        }
    }, [dispatch]);

    return <Box display={"flex"} justifyContent={"center"} margin={"0"} overflow={"auto"} width={"100%"}>
        <Box display={"flex"} justifyContent={"center"} sx={{ background: `url('${background}') center -20px repeat-x` }}  width={"100%"} minHeight={"305px"} >
            <Box display={"flex"} margin={"50px 56px"} alignItems={"center"} flexDirection={"column"} width={"100%"} maxWidth={"1288px"}>
                <Box display={"flex"} width={"100%"} justifyContent={"space-between"} alignItems={"flex-start"}>
                    <Box display={"flex"} gap={"12px"} alignItems={"center"} width={"300px"}>
                        <BackButton />
                        <Typography fontSize={"20px"} fontWeight={"500"} lineHeight={"24.38px"} textAlign={"center"}>{t('PortfolioDetailsTitle')}</Typography>
                    </Box>
                    <PortfolioProgress />
                    <Box display={"flex"} justifyContent={"end"} width={"300px"}>
                        <TimelineSelector />
                    </Box>
                </Box>
                <PortfolioDetailsCircle />
                <PortfolioMenu />
                <PortfolioDetailsTabContent />
            </Box>
        </Box>
    </Box>
}

export default PortfolioDetails;